﻿import { GetAllPermissionGroups, getTreeData, GroupPermission, GroupPermissionType, TreeDataNode } from "../../API/GroupPermissions/GroupPermissions";
import { RESTError } from "../../API/RESTError";
import { IHashData } from "../../IHashData";
import { IPage } from "../../IPage";
import { MainSite } from "../../MainSite";
import { CreateEditGroupPermissionModal } from "./CreateEditGroupPermissionModal";

export class ManagePermissionGroupsPage implements IPage {
    
    constructor(private mainSite: MainSite) {
    }

    public id: string = 'managePermissionGroups';

    public initialize(): void {

    }

    private container: JQuery = null;
    private loadingContainer: JQuery = null;
    private createEditGPModal: CreateEditGroupPermissionModal = null;

    private table: JQuery = null;
    private tableBody: JQuery = null;
    private tableHead: JQuery = null;
    private tableHeadRow: JQuery = null;

    private groupPermissions: GroupPermission[] = null;
    
    public handleHashChange(hashData: IHashData): boolean {
        if (hashData.Page === this.id) {
            if (!this.container) {
                this.refresh(this);
            }
            return true;
        } else {
            if (this.container) {
                this.container.remove();
                this.container = null;
            }
            return false;
        }
    }

    private refresh(self: any): void {
        if (self.container) {
            self.container.remove();
            self.container = null;
        }

        self.container = $('<div class="container"></div>').appendTo('body');
        self.loadingContainer = $('<div class="alert alert-info"><i class="fa fa-lg fa-fw fa-refresh fa-spin"></i> Loading...</div>').appendTo(self.container);

        /*API.GroupPermissions.AssociateUsersWithPermissionGroups((err: any, data: any) => {

        });*/

        GetAllPermissionGroups((err: any, data: GroupPermission[]) => {
            if (!err) {
                self.groupPermissions = data.sort((a, b) => a.GroupName.toLowerCase() < b.GroupName.toLowerCase() ? -1 : a.GroupName.toLowerCase() > b.GroupName.toLowerCase() ? 1 : 0);
                getTreeData((err: RESTError, data: TreeDataNode[]) => {
                    if (err) {
                        self.loadingContainer.removeClass('alert-info').addClass('alert-danger').html('<i class="fa fa-lg fa-fw fa-warning"></i> Unable to get list of data from server: ' + MainSite.escapeString(err.Message));
                    }
                    self.loadingContainer.hide();
                    self.createEditGPModal = new CreateEditGroupPermissionModal(data, self.refresh, self);
                    self.render();
                });
            } else {
                self.loadingContainer.removeClass('alert-info').addClass('alert-danger').html('<i class="fa fa-lg fa-fw fa-warning"></i> Unable to get list of data from server: ' + MainSite.escapeString(err.Message));
            }
        });
    }       
    
    public render(): void {
        $('<h1 class="midi_manageGroupPermissions_title">MANAGE GROUP PERMISSIONS</h1>').appendTo(this.container);

        $('<button type="button" class="btn btn-success midi_manageGroupPermissions_createButton">New Group Permission</button>')
            .appendTo($('<div></div>').css('margin-top','30px').appendTo(this.container))
            .click(() => {
                this.createEditGPModal.renderModal(null);
            });

        this.table = $('<table class="table table-striped table-hover midi_common_table"></table>').appendTo(this.container);
        this.tableBody = $('<tbody></tbody>').appendTo(this.table);
        this.tableHead = $('<thead></thead>').appendTo(this.table);
        this.tableHeadRow = $('<tr></tr>').appendTo(this.tableHead);
        $('<th>Group Name</th> <th>Permission</th>').appendTo(this.tableHeadRow);

        var noneFound = $('<span class="empty-message">No group permissions were added yet.</span>');

        noneFound.appendTo(this.container);

        if (this.groupPermissions.length == 0) {
            noneFound.show();
        } else {
            noneFound.hide();
            this.groupPermissions.forEach(gp => {
                var tr = $('<tr></tr>').appendTo(this.tableBody);
                $('<td>' + gp.GroupName + '</td>').appendTo(tr);
                $('<td>' + ManagePermissionGroupsPage.getGroupPermissionTypeName(gp.GroupPermissionType) + '</td>').appendTo(tr);
                tr.click(() => { this.createEditGPModal.renderModal(gp);});
            });
        }
    }

    public static getGroupPermissionTypeName(gpt: GroupPermissionType): string {
        return gpt == GroupPermissionType.View ? "View" : "View and Download";
    }
}
    

